import { author, role } from "@/custom/directives.custom";
import { App } from "vue";

export function setDirectives(app:App){
    app.directive("author", author);
    app.directive("role", role);
}